import { render, staticRenderFns } from "./KabWaropen.vue?vue&type=template&id=0b459d97"
import script from "./KabWaropen.vue?vue&type=script&lang=js"
export * from "./KabWaropen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports